import React, { useRef } from 'react';
import { LETTER_PLACEHOLDER_DRAG_TYPE } from '../../utils/letterPlaceholderConfig';

export function insertAtCursor(textarea, token) {
  if (!textarea || !token) return null;
  const start = textarea.selectionStart ?? textarea.value.length;
  const end = textarea.selectionEnd ?? start;
  const value = textarea.value ?? '';
  const next = value.slice(0, start) + token + value.slice(end);
  return { next, caret: start + token.length };
}

const LetterTemplateTextarea = ({
  id,
  label,
  value,
  onChange,
  rows = 8,
  onFocus,
  inputRef,
}) => {
  const localRef = useRef(null);
  const ref = inputRef || localRef;

  const handleDrop = (e) => {
    e.preventDefault();
    const token = e.dataTransfer.getData(LETTER_PLACEHOLDER_DRAG_TYPE)
      || e.dataTransfer.getData('text/plain');
    if (!token) return;
    const el = ref.current;
    if (!el) return;
    const result = insertAtCursor(el, token);
    if (result) {
      onChange(result.next);
      requestAnimationFrame(() => {
        el.focus();
        el.setSelectionRange(result.caret, result.caret);
      });
    }
  };

  return (
    <div className="sc-form-row letter-template-field">
      <label htmlFor={id}>{label}</label>
      <textarea
        id={id}
        ref={ref}
        rows={rows}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      />
    </div>
  );
};

export default LetterTemplateTextarea;
